import {useFormatCurrency, useFormatNumber} from 'platform/locale';
import {Pattern, match} from 'ts-pattern';

import {always} from 'ramda';

import {DEFAULT_CURRENCY} from '../../../constants/currency';
import {IndividualPriceType} from '../types/IndividualPriceType';

export const useGetDiscountValue = () => {
  const formatCurrency = useFormatCurrency();
  const formatNumber = useFormatNumber();

  return (data: IndividualPriceType) =>
    match(data)
      .with(
        {fixedPrice: Pattern.not(Pattern.nullish)},
        always(
          formatCurrency(
            data?.fixedPrice?.amount ?? 0,
            data?.fixedPrice?.currency ?? DEFAULT_CURRENCY,
            2
          )
        )
      )
      .with(
        {discountedHourlyRate: Pattern.not(Pattern.nullish)},
        always(
          formatCurrency(
            data?.discountedHourlyRate?.amount ?? 0,
            data?.discountedHourlyRate?.currency ?? DEFAULT_CURRENCY,
            2
          )
        )
      )
      .with(
        {discountOnSalePrice: Pattern.not(Pattern.nullish)},
        always(`${formatNumber(data?.discountOnSalePrice ?? 0)} %`)
      )
      .with(
        {marginToPurchasePrice: Pattern.not(Pattern.nullish)},
        always(`${formatNumber(data?.marginToPurchasePrice ?? 0)} %`)
      )
      .with(
        {percentageDiscount: Pattern.not(Pattern.nullish)},
        always(`${formatNumber(data?.percentageDiscount ?? 0)} %`)
      )
      .otherwise(always(null));
};
